export default "/_next/static/images/20/resultsDesktop-20c2c6a9e284a234e17957c3685b12bd.jpg";